"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.hasCellPriority = void 0;
var _array = require("@cbhq/cds-utils/array");
const hasCellPriority = (priorityToMatch, priority) => {
  if (!priority) return false;
  if (Array.isArray(priority)) {
    return (0, _array.arrayIncludes)(priority, priorityToMatch);
  }
  return priority === priorityToMatch;
};
exports.hasCellPriority = hasCellPriority;